<ng-container *transloco="let t">
  <form class="step step__establishment" (submit)="validateStepAndContinue($event)" novalidate>
    <dx-validation-group #validationGroup>
      <pxw-text-field
        [label]="t('establishment.name')"
        [placeholder]="t('establishment.name')"
        [rules]="[{ type: 'required', message: t('establishment.nameRequired') }]"
        [(value)]="registrationSharedService.registrationData.establishment.name"
        (keyUp)="establishmentNameChanged($event)"
        stylingMode="underlined"
      ></pxw-text-field>
      <pxw-text-field
        [label]="t('establishment.slug')"
        placeholder="{{ sampleSlug }}"
        [helper]="t('establishment.slugHelper')"
        [(value)]="registrationSharedService.registrationData.establishment.slug"
        [inputAttr]="{ id: 'input-slug' }"
        class="slug-text-field"
        stylingMode="underlined"
        (valueChange)="onSlugChanged($event)"
        >
        <label for="input-slug" class="addon-prepend url-sample"
          >{{ siteUrl }}/</label
          >
          <pxw-text-field
            [value]="registrationSharedService.registrationData.establishment.slug"
            class="input-container-withoutborders"
          [rules]="[
            { type: 'required', message: t('establishment.slugRequired') },
            { type: 'stringLength', min: 3, message: t('establishment.slugMin') },
            {
              type: 'pattern',
              pattern: slugPattern,
              message: t('establishment.slugPattern')
            }
          ]"
          [validationOnly]="true"
          stylingMode="underlined"
        ></pxw-text-field>
      </pxw-text-field>

      @if (!isCategoryPredefined) {
        <div class="ui-input">
          <label style="margin: 0; margin-bottom: 0.5em" class="ui-label">{{
            t('establishment.categories')
          }}</label>
          <dx-select-box
            [dataSource]="businessCategories"
            [placeholder]="t('establishment.categoryPlaceholder')"
            [value]="selectedCategory"
            (onValueChanged)="onCategoryChanged($event.value)"
            [noDataText]="t('establishment.categoriesNoData')"
            [searchEnabled]="true"
            searchMode="contains"
            stylingMode="underlined"
            displayExpr="label"
            valueExpr="value"
            validationMessageMode="always"
            style="padding-bottom: 0.3em"
            >
            <dx-validator>
              <dxi-validation-rule
                type="required"
                [message]="t('establishment.categoriesRequired')"
              ></dxi-validation-rule>
            </dx-validator>
          </dx-select-box>
        </div>
        @if (isOtrosSelected) {
          <pxw-text-field
            [label]="t('establishment.customCategory')"
            [placeholder]="t('establishment.customCategoryPlaceholder')"
            [(value)]="registrationSharedService.customCategoryText"
            [rules]="[{ type: 'required', message: t('establishment.customCategoryRequired') }]"
            stylingMode="underlined"
          ></pxw-text-field>
        }
      }
      <pxw-cellphone
        [label]="t('establishment.phone')"
        [placeholder]="t('establishment.phone')"
        [helper]="t('establishment.phoneHelper')"
        [(value)]="registrationSharedService.registrationData.establishment.phone"
        [(countryCode)]="registrationSharedService.registrationData.establishment.countryCode"
        [invalidMessage]="t('establishment.phoneInvalid')"
        [disabledCountryCode]="true"
        [countrySelected]="countrySelected"
        [required]="true"
        stylingMode="underlined"
      ></pxw-cellphone>
      @if (registrationSharedService.registrationData.establishment.countryCode === 'XX') {
        <div
          class="ui-input"
          >
          <pxw-text-field
            [label]="t('establishment.country')"
            [placeholder]="t('establishment.country')"
            [(value)]="registrationSharedService.registrationData.establishment.countryDetail"
            [rules]="[{ type: 'required', message: t('establishment.countryRequired') }]"
            stylingMode="underlined"
          ></pxw-text-field>
        </div>
      }
    </dx-validation-group>
    <div class="button-wrapper">
      <pxw-button display="block" type="warning" size="md" [disabled]="loading" (click)="prev()">
        <i class="ci-short_left"></i>
        {{ t('general.back') }}
      </pxw-button>
      <pxw-button mode="submit" display="block" type="warning" [loading]="loading" size="md">{{
        t('general.next')
      }}</pxw-button>
    </div>
  </form>
</ng-container>
